{
  "name": "@michelin/bibnetplatform",
  "version": "1.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration dev",
    "start-ssl": "ng serve --ssl --configuration dev",
    "build": "ng build --configuration production",
    "test": "ng test --watch=false --code-coverage",
    "lint": "ng lint --fix",
    "build-compress": "ng build --configuration production && gzipper c ./dist --include js,css,html --output-file-format [filename].[ext] ./dist-compressed/",
    "build:dev": "ng build --configuration dev",
    "build:prod": "ng build --configuration prod",
    "build-compress:prod": "npm run build:prod && gzipper c ./dist --include js,css,html --output-file-format [filename].[ext] ./dist-compressed/",
    "build-compress:dev": "npm run build:dev && gzipper c ./dist --include js,css,html --output-file-format [filename].[ext] ./dist-compressed/"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.3",
    "@angular/cdk": "^19.1.1",
    "@angular/common": "^19.1.3",
    "@angular/compiler": "^19.1.3",
    "@angular/core": "^19.1.3",
    "@angular/forms": "^19.1.3",
    "@angular/material": "^19.1.1",
    "@angular/material-moment-adapter": "^19.1.1",
    "@angular/platform-browser": "^19.1.3",
    "@angular/platform-browser-dynamic": "^19.1.3",
    "@angular/router": "^19.1.3",
    "@michelin/auth": "^5.0.2",
    "@michelin/theme": "^8.0.0",
    "hammerjs": "^2.0.8",
    "moment": "^2.30.1",
    "ngx-mask": "^19.0.1",
    "ngx-spinner": "^19.0.0",
    "overlayscrollbars": "^2.10.0",
    "rxjs": "^7.5.5",
    "tslib": "^2.6.2",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.4",
    "@angular-eslint/builder": "^19.0.2",
    "@angular-eslint/eslint-plugin": "^19.0.2",
    "@angular-eslint/eslint-plugin-template": "^19.0.2",
    "@angular-eslint/schematics": "^19.0.2",
    "@angular-eslint/template-parser": "^19.0.2",
    "@angular/cli": "^19.1.4",
    "@angular/compiler-cli": "^19.1.3",
    "@types/jasmine": "^3.6.11",
    "@types/jasminewd2": "^2.0.10",
    "@types/node": "~18.11.18",
    "@types/overlayscrollbars": "^1.12.1",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "browserslist": "^4.20.2",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^8.5.0",
    "eslint-plugin-import": "^2.26.0",
    "eslint-plugin-jsdoc": "^48.2.12",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^4.2.1",
    "husky": "^7.0.4",
    "jasmine-core": "~4.2.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.4.1",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "postcss": "^8.4.12",
    "prettier": "^2.8.3",
    "prettier-eslint": "^15.0.1",
    "pretty-quick": "^3.1.3",
    "ts-node": "~10.5.0",
    "typescript": "5.5.4"
  }
}
